<script>
import i18n from "../i18n";
import NotificationsApi from "@/services/notifications-api";
import UsersApi from "@/services/users-api";
import { eventBus } from '../main.js';

// import simplebar from "simplebar-vue";
import { layoutComputed } from "@/state/helpers";

import {Priviliges} from "../privileges";

/**
 * Horizontal-topbar component
 */
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...layoutComputed,
    notifPagesNbr() {
      return Math.ceil(this.notificationsCount / this.notifPageSize);
    },
    currentPage() {
      return this.$route.path;
    }
  },
  components: {
    // simplebar,
  },
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/french.png"),
          language: "fr",
          title: "Français",
        },
        {
          flag: require("@/assets/images/flags/us.png"),
          language: "en",
          title: "English",
        },
      ],
      current_language: null,
      text: null,
      flag: null,
      value: null,

      userFullName: '',
      userShortName : '',

      isSupplier: false,

      keyword:"",

      interval: null,

      notifications: [],
      notificationsCount: 0,
      notifPage: 1,
      notifPageSize: 3,

      role:null,

      privileges:"",
      hasCatalogAccess:false,
      isAdmin:false,
      hasOrdersListAccess:false,
      hasBackOrdersListAccess:false,
      hasInvoicesListAccess:false,
      isCustomer:false,
      hasReportingAccess:false,
      hasCustomersHistoryAcess:false,
      hasSynchronisationAccess:false,
      hasCustomerUserManagementAccess:false,
      hasTradersUserManagementAccess:false,
      hasAnnouncementsAccess:false,
      hasBannersAccess:false,

      lastConnection:null,
      filter:null,

      wsoconnected: true,
      chatMsgCount: 0,
    };
  },
  mounted() {
    this.current_language=sessionStorage.getItem("language") ? sessionStorage.getItem("language").toLowerCase(): sessionStorage.getItem("language")
    if(this.current_language){
      this.value = this.languages.find((x) => x.language === this.current_language);
      i18n.locale = this.current_language
    }else{
      this.value = this.languages.find((x) => x.language === i18n.locale );
    }

    if(this.value){
      this.text = this.value.title;
      this.flag = this.value.flag;
    }


    if(sessionStorage.getItem("privileges")!=null){
      this.privileges=sessionStorage.getItem("privileges")
      this.hasCatalogAccess=this.privileges.includes(Priviliges[0]["Catalog_Access"] ) 
      this.isAdmin=this.privileges.includes(Priviliges[0]["Admin_Role"] )
      this.hasOrdersListAccess= this.privileges.includes(Priviliges[0]["OrderList_Access"] )
      this.isCustomer= this.privileges.includes(Priviliges[0]["Customer_Role"] )
      this.hasReportingAccess=this.privileges.includes(Priviliges[0]["Sales_Statistics_Access"] )
      this.hasCustomersHistoryAcess=this.privileges.includes(Priviliges[0]["Customer_Histories_Access"] )
      this.hasSynchronisationAccess=this.privileges.includes(Priviliges[0]["Synchronization_Reports_Access"] )
      this.hasBackOrdersListAccess=this.privileges.includes(Priviliges[0]["BackOrder_Access"] )
      this.hasInvoicesListAccess=this.privileges.includes(Priviliges[0]["InvoicesList_Access"] )
      this.hasCustomerUserManagementAccess=this.privileges.includes(Priviliges[0]["Customer_User_Management"] )
      this.hasTradersUserManagementAccess=this.privileges.includes(Priviliges[0]["Supplier_User_Management"] )
      this.hasAnnouncementsAccess=this.privileges.includes(Priviliges[0]["Announcements_Management"] )
      this.hasBannersAccess=this.privileges.includes(Priviliges[0]["Advertising_Banners_Management"] )
    }

     if (sessionStorage.getItem("userFullName") != null) {
      this.userFullName = sessionStorage.getItem("userFullName");
      this.userShortName = this.userFullName != null ? this.userFullName.split(' ')[0] : '';
    }
    
    this.isSupplier = sessionStorage.getItem("userr") == 1;
    // if (this.isSupplier) {
    //   this.getSupplierName();
    // }

    this.role=sessionStorage.getItem("userr");
    this.getLastConnection()

    document.getElementById("topnav-menu-content").classList.toggle("hide")	
    
  },
  created() {
    this.getNotifications() // first run
    this.interval = setInterval(this.getNotifications, 120000)

    eventBus.$on('notif_chat_new', (result) => {
      this.chatMsgCount = result;
    })
  },
  beforeDestroy () {
    clearInterval(this.interval);
  },

  
  methods: {
    
    toggleRightSidebar() {	
      this.$parent.toggleRightSidebar();	
    },	
    toggleMenu() {	
      let element = document.getElementById("topnav-menu-content");	
      element.classList.toggle("show");	
    },	
    initFullScreen() {	
      document.body.classList.toggle("fullscreen-enable");	
      if (	
        !document.fullscreenElement &&	
        /* alternative standard method */ !document.mozFullScreenElement &&	
        !document.webkitFullscreenElement	
      ) {	
        // current working methods	
        if (document.documentElement.requestFullscreen) {	
          document.documentElement.requestFullscreen();	
        } else if (document.documentElement.mozRequestFullScreen) {	
          document.documentElement.mozRequestFullScreen();	
        } else if (document.documentElement.webkitRequestFullscreen) {	
          document.documentElement.webkitRequestFullscreen(	
            Element.ALLOW_KEYBOARD_INPUT	
          );	
        }	
      } else {	
        if (document.cancelFullScreen) {	
          document.cancelFullScreen();	
        } else if (document.mozCancelFullScreen) {	
          document.mozCancelFullScreen();	
        } else if (document.webkitCancelFullScreen) {	
          document.webkitCancelFullScreen();	
        }	
      }	
    },
   
    setLanguage(locale, country, flag) {
      this.current_language = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
      UsersApi.setLanguage(this.current_language).then(
        (result)=>{
          if(result){
            sessionStorage.setItem("language",result)
          }
        }
      )

    },

    search() {
      this.$router.push({ name: 'Recherche', query: { keyword: this.keyword } })
    },

    getNotifications() {

      NotificationsApi.getNotifications(this.notifPage -1 ,this.notifPageSize)
      .then(notif => {
        if (notif) {
          this.notifications = notif.notifications;
          this.notificationsCount = notif.count;
        }
      })

      this.getChatMsgCount();
    },

    getChatMsgCount() {
      NotificationsApi.getInstantChatMsgCount()
      .then(result => {
          this.chatMsgCount = result;
          if(this.chatMsgCount!=0){
            eventBus.$emit("notif_chat_new", this.chatMsgCount);
          }
      })          
    },

    toNotificationIcon(notificationType) {
      if (notificationType == null) {
        return;
      }
      switch (notificationType) {
        case 0: return "fas fa-dolly";
        case 1: return "fas fa-check-double";
        case 2: return "fas fa-truck-loading";
        case 3: return "fas fa-exclamation-triangle";
        default : return "fas fa-dolly";
      }
    },

    toNotificationColor(notificationType) {
      if (notificationType == null) {
        return;
      }
      switch (notificationType) {
        case 0: return "bg-danger";
        case 1: return "bg-info";
        case 2: return "bg-success";
        case 3: return "bg-secondary";
        default : return "bg-secondary";
      }
    },

    getLastConnection(){
      UsersApi.getLastConnection().then(
        (result)=>{
          this.lastConnection=result
        }
      )
    },

    findItems(){
      if(this.filter == null){
        return ;
      }
      this.$router.push({ name:'Addneworder' ,path: '/orders/newOrder', query: {filter:this.filter, isHomePageRequest:true}})
    },
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-topbar", "dark");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "light");
              document.body.removeAttribute("data-layout-size", "boxed");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "colored":
              document.body.setAttribute("data-topbar", "colored");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            default:
              document.body.setAttribute("data-topbar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              break;
            case "scrollable":
              document.body.setAttribute("data-layout-scrollable", "true");
              document.body.removeAttribute("data-layout-mode");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
  },
};
</script>

<style scoped>

.selected-blue-menu {
  border-bottom: 3px solid #2a2c74;
}

</style>

<template>
  <header id="page-topbar">
    <div class="navbar-header" style="background-color: #fec235; box-shadow: 0 0px 15px 2px #202c73;">
      <div class="d-flex ">
        <!-- LOGO -->
        <div class="bg-white pr-0 ">
          <router-link to="/" class="logo logo-light">
            <span class="d-none d-sm-inline bg-white p-2" >
              <img src="@/assets/images/logo.png" alt height="55" style="margin-bottom: 0px;" />
            </span>
            <span class="d-inline d-sm-none bg-white p-2" >
              <img src="@/assets/images/logo-mini.jpg" alt height="40" style="margin-bottom: 3px;" />
            </span>
          </router-link>
        </div>

        <div class="d-none d-sm-inline" style="width: 0px;
          height: 0;
          border-left: 45px solid white;
          border-top: 70px solid #fec235;">
        </div>

        <button
          id="toggle"
          type="button"
          class="btn btn-sm mr-2 font-size-20 d-lg-none header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars text-primary" ></i>
        </button>

       
        <!-- App Search-->
        <!-- <b-form v-on:submit.prevent="" class="app-search d-none d-lg-block" v-if="!this.isSupplier">
          <div class="position-relative">
            <b-input type="text" class="form-control text-primary bg-white" v-model="keyword" placeholder="Cherchez par OEM ou Référence" @keyup.native.enter="search()"/>
            <span class="bx bx-search-alt text-primary"></span>
          </div>
        </b-form> -->
        
        <!-- Home-->
        <router-link  tag="a" to="/" ><button :class="currentPage == '/' ? '' : 'text-muted'" class="text-primary d-none d-lg-block btn header-item pb-0 ">
            <span class="font-size-16" ><i class="fas fa-home text-primary" style="font-size:28px;"></i><br><span>{{ $t("menuitems.dashboard.text") }}</span></span>
        </button></router-link>

        <!-- Catalog -->
        <router-link v-if="(hasCatalogAccess||isAdmin || isCustomer)" tag="a" to="/orders/newOrder" ><button :class="currentPage.includes('/orders/newOrder') ? 'selected-blue-menu' : 'text-muted'" class="text-primary d-none d-lg-block btn header-item pb-0">
            <span class="font-size-16" ><i class="fas fa-cart-plus text-primary" style="font-size:28px;"></i><br><span>{{ $t("menuitems.newOrder.text") }}</span></span>
        </button></router-link>
        <!-- <router-link v-if="role==1 && (hasCatalogAccess||isAdmin)" tag="a" to="/supplier/catalog" ><button :class="currentPage.includes('/supplier/catalog') ? 'selected-blue-menu' : 'text-muted'" class="text-primary d-none d-lg-block btn header-item pb-0">
            <span class="font-size-16" ><i class="fas fa-shopping-cart text-primary" style="font-size:28px;"></i><br><span>{{ $t("menuitems.newOrder.text") }}</span></span>
        </button></router-link> -->

        <!-- Orders List -->
        <router-link v-if="hasOrdersListAccess|| hasBackOrdersListAccess || hasInvoicesListAccess || isAdmin||isCustomer || hasCatalogAccess "  tag="a" to="/orders/list" ><button :class="currentPage.includes('/orders/list') ? 'selected-blue-menu' : 'text-muted'" class="text-primary d-none d-lg-block btn header-item pb-0">
            <span class="font-size-16" ><i class="fas fa-dolly text-primary" style="font-size:28px;"></i><br><span>{{ $t("menuitems.orders.text") }}</span></span>
        </button></router-link> 

        <!-- Reporting button -->
        <router-link v-if="hasReportingAccess|| hasCustomersHistoryAcess || hasSynchronisationAccess || isAdmin||isCustomer "  tag="a" to="/reporting" ><button :class="currentPage.includes('/reporting') ? 'selected-blue-menu' : 'text-muted'" class="text-primary d-none d-lg-block btn header-item pb-0">
            <span class="font-size-16" ><i class="fas fa-chart-line text-primary" style="font-size:28px;"></i><br><span>{{ $t("menuitems.reporting.text") }}</span></span>
        </button></router-link>

        <!-- Subscription -->
        <router-link  v-if="role==1 && (isAdmin || hasCustomerUserManagementAccess || hasTradersUserManagementAccess)" tag="a" to="/listOfUsers" ><button :class="currentPage.includes('/listOfUsers') ? 'selected-blue-menu' : 'text-muted'" class="text-primary d-none d-lg-block btn header-item pb-0">
            <span class="font-size-16" ><i class="fas fa-users text-primary" style="font-size:28px;"></i><br><span>{{ $t("menuitems.subscription.text") }}</span></span>
        </button></router-link>

        <!-- banner button -->
        <router-link v-if="role==1 && (isAdmin || hasAnnouncementsAccess || hasBannersAccess)" tag="a" to="/parameters" ><button :class="currentPage.includes('/parameters') ? 'selected-blue-menu' : 'text-muted'" class="text-primary d-none d-lg-block btn header-item pb-0">
            <span class="font-size-16" ><i class="fas fa-cogs text-primary" style="font-size:28px;"></i><br><span>{{ $t("menuitems.parameters.text") }}</span></span>
        </button></router-link>

      
      </div>

      <div class="d-flex">

        <!-- <div class="dropdown d-none d-lg-inline-block ml-1">
          <button type="button" @click="toggleRightSidebar" class="btn header-item noti-icon btn header-item noti-icon right-bar-toggle toggle-right">
            <i class="bx bx-chat  text-primary font-size-24"></i>
            <span class="badge badge-danger badge-pill">1</span>
          </button>
        </div> -->

        <!-- <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="bx bx-chat toggle-right  text-primary font-size-24"></i>
            <span class="badge badge-danger badge-pill">1</span>
          </button>
        </div> -->

        

        <b-dropdown
          class="d-block d-sm-none ml-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify text-primary" style=" font-size:30px;"></i>
          </template>

          <form class="p-3 " v-on:submit.prevent="">
            <div class="form-group m-0">
              <div class="input-group">
                <b-input
                  type="text"
                  class="form-control"
                  :placeholder="$t('customerHomePage.search.placeholder')"
                  v-model="filter"
                  @keyup.native.enter="findItems()"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit" @click="findItems()">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>
<!-- 
        <b-dropdown variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            <img class :src="flag" alt="Header Language" height="16" />
            {{ text }}
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)"
            :class="{ active: current_language === entry.language }"
          >
            <img
              :src="`${entry.flag}`"
              alt="user-image"
              class="mr-1"
              height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown> -->

        <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="bx bx-bell text-primary" style=" font-size:30px;"></i>
            <span
              class="badge badge-danger badge-pill" :class="notificationsCount == 0 ? 'd-none' : ''"
            >{{notificationsCount}}</span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">{{ $t('dropDown.notification.text')}}</h6>
              </div>
              <div class="col-auto">
                <!-- <a href="#" class="small">{{ $t('navbar.dropdown.notification.subtext')}}</a> -->
              </div>
            </div>
          </div>
          <!-- <simplebar style="max-height: 230px;"> -->
            
            <div v-for="notif in notifications" :key="notif.id">
              <router-link :to="{ path: '/orders/order', query: { orderId: notif.orderId }}">
                <a href="javascript: void(0);" class="text-reset notification-item">
                  <div class="media">
                    <div class="avatar-xs mr-3">
                      <span class="avatar-title rounded-circle font-size-16" :class="toNotificationColor(notif.type)">
                        <i :class="toNotificationIcon(notif.type)"></i>
                      </span>
                    </div>
                    <div class="media-body">
                      <h6 class="mt-0 mb-1">{{notif.message}}</h6>
                      <div class="font-size-12 text-muted">
                        <!-- <p class="mb-1">Nouvelle commande</p> -->
                        <p class="mb-0">
                          <i class="mdi mdi-clock-outline"></i>
                          {{ notif.date }}
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </router-link>

            </div>
          <!-- </simplebar> -->
          <div class="p-2 border-top">
            <div class="row">

            <div class="col-2">
                 <a class="btn btn-sm btn-light btn-block text-center" :class="notifPage <= 1 ? 'd-none' : ''" @click="notifPage--; getNotifications();"  href="javascript:void(0)">
                    <i class="fas fa-backward text-left" ></i>    
                </a>

              </div>

            <div class="col-8 text-center pt-1">
              <span class="mr-2 ml-2 text-muted font-weight-bold" :class="notifPage == 1 ? 'd-none': ''">Page {{notifPage}}</span>
            </div>

              <div class="col-2">
                 <a class="btn btn-sm btn-light btn-block text-center" :class="notifPage >= notifPagesNbr ? 'disabled' : ''" href="javascript:void(0)" @click="notifPage++; getNotifications();">
                  <i class="fas fa-forward text-right" ></i>
                    
                </a>

              </div>
              
            </div>

          </div>
        </b-dropdown>

        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="far fa-comment-alt toggle-right font-size-24" :class="wsoconnected ? 'text-primary' : 'text-muted'" ></i>
            <span class="badge badge-danger badge-pill" :class="chatMsgCount == 0 ? 'd-none' : ''">{{chatMsgCount}}</span>
          </button>
        </div>

        <!-- <div class="dropdown d-none d-lg-inline-block ml-1">
          <button type="button" @click="toggleRightSidebar" class="btn header-item noti-icon btn header-item noti-icon right-bar-toggle toggle-right">
            <i class="far fa-comment-alt  text-primary font-size-24"></i>
            <span class="badge badge-danger badge-pill">6</span>
          </button>
        </div> -->


        <b-dropdown
          toggle-class="header-item noti-icon" right  variant="black">
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)"
            :class="{ active: current_language === entry.language }"
          >
            <img
              :src="`${entry.flag}`"
              alt="user-image"
              class="mr-1"
              height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
          <template v-slot:button-content>
            <i class="bx bx-world text-primary" style="font-size:30px;"></i>
            <span class="badge badge-info badge-pill">{{current_language}}</span>
          </template>

<!-- 
          <a href="javascript:void(0);" class="dropdown-item notify-item">
            <img src="@/assets/images/flags/french.png" alt="user-image" class="mr-1" height="12" />
            <span class="align-middle">Français</span>
          </a>

          <a href="javascript:void(0);" class="dropdown-item notify-item">
            <img src="@/assets/images/flags/us.png" alt="user-image" class="mr-1" height="12" />
            <span class="align-middle">English</span>
          </a> -->
   
        </b-dropdown>

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user bg-primary"
              src="@/assets/images/users/avatar-1.png"
              alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ml-1 text-primary" style="font-size:15px;font-weight:bold;">{{userShortName}}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block text-primary" style="font-size:15px;"></i>
          </template>
          <!-- item-->
          <b-dropdown-item v-if="lastConnection">
            <span style="cursor:default">
              <i class="bx bx-time-five font-size-16 align-middle mr-1"></i>
              {{ $t('dropDown.lastConnection.text') }}  <span class="font-weight-bold text-primary" > {{lastConnection}}</span>
            </span>
          </b-dropdown-item>

          <b-dropdown-divider v-if="isCustomer && lastConnection"></b-dropdown-divider>
          <b-dropdown-item>

            <router-link tag="span" to="/profil">
              <i class="bx bx-user font-size-16 align-middle mr-1"></i>
              {{ $t('dropDown.profil.text') }}  {{userFullName}}
            </router-link>
          </b-dropdown-item>

          <!-- <b-dropdown-divider></b-dropdown-divider> -->
          <a href="/logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
            {{ $t('dropDown.logOut.text') }}
          </a>
        </b-dropdown>

        <!-- <div class="dropdown d-inline-block">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="bx bx-cog bx-spin toggle-right"></i>
          </button>
        </div> -->

        
      </div>
    </div>
  </header>
</template>